import gql from 'graphql-tag';

export const CURRENT_STORE_QUERY =
gql`
  query {
    storeNow {
      store_id
      name
      domain
      customer_service_phone_number
      facebook_fanpage_id
      logo {
        file_id
        path
      }
    }
  }
`;
